import { render, staticRenderFns } from "./comLayout3.vue?vue&type=template&id=81d61b9e&scoped=true&"
import script from "./comLayout3.vue?vue&type=script&lang=js&"
export * from "./comLayout3.vue?vue&type=script&lang=js&"
import style0 from "./comLayout3.vue?vue&type=style&index=0&id=81d61b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d61b9e",
  null
  
)

export default component.exports